"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleMobileTray = exports.localeMobileMenuId = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const pathname_1 = require("../../context/pathname");
const shared_1 = require("../../shared");
const localeUtils_1 = require("../../utils/localeUtils");
const tray_1 = require("../tray");
exports.localeMobileMenuId = "locale-mobile";
const Styled = styled_components_1.default.div `
	visibility: ${(p) => (p.menuOpen ? "visible" : "hidden")};
	&:hover {
		visibility: visible;
	}
	position: absolute;
	top: 0;
	background: ${(p) => p.theme.palette.background.paper};
	left: ${(p) => (p.menuOpen ? 0 : "100%")};
	transition: left 0.2s ease-in-out;
	width: 100%;
	height: 100%;
`;
const LocaleMobileTray = ({ hide, locale, localeOptions }) => {
    const { messages } = (0, shared_1.useMessages)();
    const getMessage = (0, epic_games_nav_shared_1.useLocalization)();
    const { menuOpen, setMenuOpen } = (0, shared_1.useLocaleMobileTray)();
    const toggleMenu = (0, shared_1.useToggleMenu)(menuOpen, setMenuOpen, exports.localeMobileMenuId);
    const onKeyUp = (0, shared_1.useHandleKeyUp)(toggleMenu, toggleMenu);
    const isLegacyLinkBehaviour = (0, epic_games_nav_shared_1.useLegacyLinkBehaviour)();
    const pathname = (0, pathname_1.usePathname)();
    if (hide)
        return null;
    const { sortedLocaleOptions = [] } = (0, localeUtils_1.getSortedLocaleOptions)(localeOptions, locale, messages.locale);
    const dropdownLinks = sortedLocaleOptions.map((localeOption) => {
        if (localeOption.lang && localeOption.lang !== locale) {
            const href = isLegacyLinkBehaviour ? (0, localeUtils_1.getLocaleHref)(localeOption, locale) : pathname;
            const title = localeOption.name.indexOf(".") > -1 ? getMessage(localeOption.name) : localeOption.name;
            return Object.assign(Object.assign({}, localeOption), { href, title, target: localeOption.target || "_self" });
        }
    });
    return (react_1.default.createElement(Styled, { role: "menu", menuOpen: menuOpen },
        react_1.default.createElement(tray_1.TrayContent, { className: "tray-content", menuOpen: menuOpen },
            react_1.default.createElement(tray_1.BackTrayItem, { toggleMenu: toggleMenu, menuOpen: menuOpen, onKeyUp: onKeyUp }),
            react_1.default.createElement(tray_1.MobileLinks, { menuOpen: menuOpen, links: dropdownLinks, locale: locale, disableHrefTemplate: true }))));
};
exports.LocaleMobileTray = LocaleMobileTray;
//# sourceMappingURL=LocaleMobileTray.js.map